import { Button } from '@mui/material';
import React from 'react';
import { enqueueSnackbar, closeSnackbar } from 'notistack';

export const useNotificationsManager = () => {
  const showSuccessNotification = (message: string) => {
    enqueueSnackbar(message, {
      variant: 'success',
      persist: false
    });
  };
  const showErrorNotification = (message: string) => {
    enqueueSnackbar(message, {
      variant: 'error',
      persist: true,
      action: () => (
        <Button
          color="inherit"
          variant="outlined"
          onClick={() => {
            closeSnackbar();
          }}
        >
          OK
        </Button>
      )
    });
  };

  return {
    showErrorNotification,
    showSuccessNotification
  };
};
